import client from "./client";

export const listDepartments = async () => (await client.get("/departments")).data;
export const createDepartment = async (body, force = false) =>
  (await client.post("/departments", body, { params: { force } })).data;
export const updateDepartment = async (id, body, force = false) =>
  (await client.put(`/departments/${id}`, body, { params: { force } })).data;
export const deleteDepartment = (id) => client.delete(`/departments/${id}`);

export const listDeptMembers = async (deptId) =>
  (await client.get(`/departments/${deptId}/members`)).data;
export const listDeptCandidates = async (deptId, q = "") =>
  (await client.get(`/departments/${deptId}/candidates`, { params: { q } })).data;
export const addDeptMember = (deptId, userId) =>
  client.post(`/departments/${deptId}/members/${userId}`);
export const removeDeptMember = (deptId, userId) =>
  client.delete(`/departments/${deptId}/members/${userId}`);
